var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserEmptyNoBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 37,
    r: 36,
    fill: "currentColor"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1895_98226)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.9995 36.9999C39.2246 36.9999 41.3996 36.3401 43.2497 35.1039C45.0997 33.8677 46.5417 32.1107 47.3932 30.055C48.2446 27.9994 48.4674 25.7374 48.0333 23.5551C47.5993 21.3728 46.5278 19.3682 44.9545 17.7949C43.3811 16.2216 41.3766 15.1501 39.1943 14.716C37.012 14.2819 34.75 14.5047 32.6943 15.3562C30.6387 16.2077 28.8816 17.6496 27.6455 19.4997C26.4093 21.3497 25.7495 23.5248 25.7495 25.7499C25.7525 28.7326 26.9387 31.5924 29.0479 33.7015C31.157 35.8107 34.0167 36.9969 36.9995 36.9999ZM36.9995 18.2499C38.4829 18.2499 39.9329 18.6897 41.1663 19.5138C42.3997 20.3379 43.361 21.5093 43.9286 22.8797C44.4963 24.2502 44.6448 25.7582 44.3554 27.213C44.066 28.6679 43.3517 30.0043 42.3028 31.0532C41.2539 32.1021 39.9175 32.8164 38.4627 33.1057C37.0078 33.3951 35.4998 33.2466 34.1294 32.679C32.7589 32.1113 31.5876 31.15 30.7635 29.9166C29.9394 28.6833 29.4995 27.2332 29.4995 25.7499C29.4995 23.7607 30.2897 21.8531 31.6962 20.4466C33.1027 19.04 35.0104 18.2499 36.9995 18.2499V18.2499Z",
    fill: "#DFDFEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.001 40.7511C32.527 40.7561 28.2376 42.5356 25.074 45.6992C21.9104 48.8628 20.1309 53.1521 20.126 57.6261C20.126 58.1234 20.3235 58.6003 20.6752 58.9519C21.0268 59.3036 21.5037 59.5011 22.001 59.5011C22.4983 59.5011 22.9752 59.3036 23.3268 58.9519C23.6784 58.6003 23.876 58.1234 23.876 57.6261C23.876 54.1451 25.2588 50.8067 27.7202 48.3453C30.1816 45.8839 33.52 44.5011 37.001 44.5011C40.4819 44.5011 43.8203 45.8839 46.2818 48.3453C48.7432 50.8067 50.126 54.1451 50.126 57.6261C50.126 58.1234 50.3235 58.6003 50.6751 58.9519C51.0268 59.3036 51.5037 59.5011 52.001 59.5011C52.4983 59.5011 52.9752 59.3036 53.3268 58.9519C53.6784 58.6003 53.876 58.1234 53.876 57.6261C53.871 53.1521 52.0915 48.8628 48.9279 45.6992C45.7643 42.5356 41.475 40.7561 37.001 40.7511V40.7511Z",
    fill: "#DFDFEB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1895_98226"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "currentColor",
    transform: "translate(14.5 14.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserEmptyNoBorder);
export default __webpack_public_path__ + "static/media/user-empty-no-border.f65389e22ccde137953248fb21a5e827.svg";
export { ForwardRef as ReactComponent };